import { BitkitBadgeProps } from '@bitrise/bitkit-v2';

import { getBuildStatusIconName, getBuildStatusText, isBuildRunning, PublicApiBuild } from '@/models/Build';

import getBuildStatusDecorator from '../../utils/getBuildStatusDecorator';
import StatusTag from './StatusTag';
import { StatusTagProps } from './types/StatusTagProps';

export type BuildStatusTagProps = Pick<StatusTagProps, 'size' | 'className' | 'fixedWidth' | 'progress'> & {
  build: PublicApiBuild;
  colorScheme?: BitkitBadgeProps['colorVariant'];
};

const BuildStatusTag = ({ size, className, fixedWidth, progress, build, colorScheme }: BuildStatusTagProps) => (
  <StatusTag
    backgroundColor={getBuildStatusDecorator(build).backgroundColor}
    className={className}
    fixedWidth={fixedWidth}
    icon={getBuildStatusIconName(build)}
    isRunning={isBuildRunning(build)}
    progress={progress}
    size={size}
    text={getBuildStatusText(build)}
    textColor={getBuildStatusDecorator(build).textColor}
    colorScheme={colorScheme}
  />
);

export default BuildStatusTag;
